import { render, staticRenderFns } from "./riskRule.vue?vue&type=template&id=3b748963&scoped=true"
import script from "./riskRule.vue?vue&type=script&lang=js"
export * from "./riskRule.vue?vue&type=script&lang=js"
import style0 from "./riskRule.vue?vue&type=style&index=0&id=3b748963&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b748963",
  null
  
)

export default component.exports